var calculatorAreaForm = document.querySelector('form[name="calculator-area"]')
if (calculatorAreaForm !== null) {
  calculatorAreaForm.addEventListener("submit", function(event){
    event.preventDefault();
    document.querySelector('.calculator-area-result').style.display = 'none';
    var typeWallMulti = {
        "ANCIENNE_PEINTURE": 0.083333,
        "PLATRE": 0.083333,
        "BRIQUE": 0.166666,
        "CREPI": 0.166666,
        "FIBRE_DE_VERRE": 0.166666,
        "PAPIER_PEINT": 0.166666,
        "BETON_CELLULAIRE": 0.25,
        "PARPAING": 0.25,
    };
    const datas = new FormData(event.target);
    var typeWall = datas.get('typeWall');
    var nbDoor = datas.get('nbDoor');
    var nbWindow = datas.get('nbWindow');
    var wallWidth = datas.get('wallWidth');
    var wallHeight = datas.get('wallHeight');
    var nbCouche = datas.get('nbCouche');
    var paintQtt = Math.round((((wallWidth * wallHeight - (nbWindow * 1) - (nbDoor * 1.5)) * nbCouche) * typeWallMulti[typeWall] + Number.EPSILON) * 100) / 100;
    document.getElementById('calculator-area-result-area').innerHTML = (wallWidth * wallHeight - (nbWindow * 1) - (nbDoor * 1.5)) + 'm<sup>2</sup>'
    document.getElementById('calculator-area-result-quantity').innerHTML = paintQtt + 'L'
    document.querySelector('.calculator-area-result').style.display = 'block';
  }, false);
}